import { InvoiceIncomingCostAllocation } from "services/api/finance/incoming-invoices/types";
import { InvoiceIncomingAllocationTargets } from "./types";

/** Vozila i troškovi tvrtke na koje je račun otišao, svaki naziv jednom. */
export const splitAllocationTargets = (
  allocations: InvoiceIncomingCostAllocation[]
): InvoiceIncomingAllocationTargets => {
  const vehicles: string[] = [];
  const expenseTypes: string[] = [];

  allocations.forEach(allocation => {
    // Trošak bez vozila je trošak tvrtke, pa ga imenuje vrsta troška.
    if (allocation.vehicleId) {
      const name = allocation.vehicleName ?? allocation.vehicleId;
      if (!vehicles.includes(name)) vehicles.push(name);
      return;
    }

    if (!allocation.expenseTypeId) return;

    const name = allocation.expenseTypeName ?? "Trošak tvrtke";
    if (!expenseTypes.includes(name)) expenseTypes.push(name);
  });

  return { vehicles, expenseTypes };
};

/** Popis naziva skraćen na zadani broj; ostatak se sažme u „(+n)". */
const joinNames = (names: string[], limit: number): string =>
  names.length > limit
    ? `${names.slice(0, limit).join(", ")} (+${names.length - limit})`
    : names.join(", ");

/**
 * Puna rečenica o tome na što je račun raspoređen — „Raspoređeno na vozila ZG123, ZG456" ili
 * „Raspoređeno na troškove tvrtke Uredski materijal", a kad ima oboje, spojeno s „i".
 */
export const buildAllocationLabel = (
  targets: InvoiceIncomingAllocationTargets,
  limit: number
): string => {
  const parts: string[] = [];

  if (targets.vehicles.length > 0) {
    const noun = targets.vehicles.length === 1 ? "vozilo" : "vozila";
    parts.push(`${noun} ${joinNames(targets.vehicles, limit)}`);
  }

  if (targets.expenseTypes.length > 0) {
    const noun = targets.expenseTypes.length === 1 ? "trošak tvrtke" : "troškove tvrtke";
    parts.push(`${noun} ${joinNames(targets.expenseTypes, limit)}`);
  }

  return `Raspoređeno na ${parts.join(" i ")}`;
};
